var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card company-card",
      class: { "expanded-card": _vm.isExpanded }
    },
    [
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "media vertical-center" }, [
          _vm.suite.logo_path
            ? _c("figure", { staticClass: "media-left" }, [
                _c("p", { staticClass: "image w-12 h-10 lg:w-16 lg:h-16" }, [
                  _c("img", {
                    staticClass: "square-logo",
                    attrs: {
                      src: _vm.fixHttpProtocol(_vm.suite.logo_path),
                      alt: ""
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "media-content is-flex vertical-center" }, [
            _c("div", [
              _c("p", { staticClass: "title is-5" }, [
                _vm._v(_vm._s(_vm.suite.company.name))
              ]),
              _vm._v(" "),
              _vm.showParentCompany
                ? _c("p", { staticClass: "subtitle is-6" }, [
                    _vm._v(
                      "\n            " + _vm._s(_vm.suite.name) + "\n          "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "company-description" }, [
          _c("span", { staticStyle: { "white-space": "pre-wrap" } }, [
            _c("p", {
              directives: [{ name: "linkified", rawName: "v-linkified" }],
              domProps: { textContent: _vm._s(_vm.suite.description) }
            }),
            _vm._v(" "),
            _vm.showParentCompany && _vm.suite.company.description
              ? _c("p", { staticClass: "mt-4" }, [
                  _c("b", [_vm._v("About " + _vm._s(_vm.suite.company.name))]),
                  _c("br"),
                  _vm._v(_vm._s(_vm.suite.company.description) + "\n        ")
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("footer", { staticClass: "card-footer" }, [
        _c(
          "p",
          { staticClass: "card-footer-item" },
          [
            _c(
              "router-link",
              {
                staticClass: "button is-small is-primary is-inverted",
                attrs: {
                  to: {
                    name: "ExhibitorSchedule",
                    params: { suiteId: _vm.suite.id }
                  },
                  exact: ""
                }
              },
              [
                _c("span", { staticClass: "icon is-small" }, [
                  _c("i", { staticClass: "fas fa-arrow-right" })
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("Book Appointment")])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.suite.description && _vm.suite.description.length > 0
          ? _c("p", { staticClass: "card-footer-item" }, [
              _c(
                "button",
                {
                  staticClass: "button is-small is-text",
                  staticStyle: { "text-decoration": "none" },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.isExpanded = !_vm.isExpanded
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.isExpanded ? "Hide Info" : "More Info") +
                      "\n      "
                  )
                ]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-544b52f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-544b52f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CompanyCard.vue
// module id = null
// module chunks = 